import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function updateUtteranceReviewedStatus(requestData, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.patch("api/reviewUtteranceFlagsSelected", {
      ...requestData,
      userKey,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
